import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import MetaProducao from "model/meta/producao/MetaProducao";
import MetaProducaoHorario from "model/meta/producao/MetaProducaoHorario";
import MetaProducaoOperacao from "model/meta/producao/MetaProducaoOperacao";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { useInterval } from 'primereact/hooks';
import { useEffect, useState } from "react";
import MetaProducaoDashboardService from "service/meta/producao/MetaProducaoDashboardService";
import { converterData, converterHorario } from "utils/convert";

const metaProducaoDashboardService = new MetaProducaoDashboardService();
export default function MetaProducaoDashboard() {

    const [data, setData] = useState<Date | null>(new Date());
    const [metas, setMetas] = useState<MetaProducao[]>([]);

    const [meta, setMeta] = useState<MetaProducao | null>(null);
    const [metaOperacao, setMetaOperacao] = useState<MetaProducaoOperacao | null>(null);

    const [total, setTotal] = useState<number>(0);

    const [metaComApontamentos, setMetaComApontamentos] = useState<MetaProducao | null>(null);

    useInterval(() => {
        if (metaOperacao) {
            loadMeta(metaOperacao?.id || 0);
        }
    }, 120000);

    useEffect(() => {
        if (data) {
            loadMetas();
        }
    }, [data]);

    useEffect(() => {
        if (metaOperacao) {
            loadMeta(metaOperacao?.id || 0);
        }
    }, [metaOperacao]);

    function loadMetas() {
        metaProducaoDashboardService.buscarMetas(converterData(data)).then((data) => {
            setMetas(data);
            if (data.length > 0) {
                setMeta(data[0]);
                setMetaOperacao(data[0].operacoes[data[0].operacoes.length - 1]);
            } else {
                setMeta(null);
                setMetaOperacao(null);
                setMetaComApontamentos(null);
                setTotal(0);
            }
        }).catch(err => {
            console.error(err);
        });
    }

    function loadMeta(idMetaOperacao: number) {
        metaProducaoDashboardService.buscarMeta(idMetaOperacao).then((data) => {
            let total = 0;
            data?.horarios.forEach(horario => {
                let soma = 0;
                if (horario.apontamentos) {
                    horario.apontamentos.map(apontamento => {
                        soma += apontamento.quantidade;
                    })
                }
                horario.total = soma;
                total += soma;

                let somaDefeito = 0;
                if (horario.apontamentosDefeito) {
                    horario.apontamentosDefeito.map(apontamento => {
                        somaDefeito += apontamento.quantidade;
                    })
                }
                horario.totalDefeito = somaDefeito;
            });
            setTotal(total);
            setMetaComApontamentos(data);

        }).catch(err => {
            console.error(err);
        });
    }

    function isDesktop() {
        return window.innerWidth >= 1024;
    }

    const renderImage = (caminho: string) => {
        return <img src={caminho} alt="Imagem" style={{ width: 50, height: 50 }} />
    }

    return (
        <>
            <div style={{ display: "flex", columnGap: 20 }}>
                <DataTable value={metaComApontamentos?.horarios} emptyMessage="Nenhum registro encontrado">
                    <Column header="Horários" headerStyle={{ color: "#FFF", fontSize: 20, background: "#240E92" }} style={{ width: 160, fontSize: 20 }} body={(rowData: MetaProducaoHorario) => converterHorario(rowData.horaInicio) + " às " + converterHorario(rowData.horaFim)} />
                    <Column header="Total" headerStyle={{ color: "#FFF", background: "#240E92", display: "flex", justifyContent: "right", fontSize: 20 }} style={{ width: 100, textAlign: "right", fontSize: 28 }} body={(rowData: MetaProducaoHorario) => rowData.total} />
                    <Column header="" headerStyle={{ color: "#FFF", background: "#240E92" }} body={
                        (rowData: MetaProducaoHorario) => metaComApontamentos && rowData.total >= Math.floor(metaComApontamentos.quantidade / metaComApontamentos.horarios.length) ?
                            renderImage("/imagens/checkmark.png")
                            :
                            renderImage("/imagens/crossmark.png")
                    } />
                </DataTable>
                <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>

                        <DatePicker
                            sx={{ width: '32%' }}
                            value={dayjs(data)}
                            onChange={value => {
                                setData(value?.toDate() || null);
                            }}
                        />

                        <Dropdown
                            value={meta}
                            placeholder="Selecione uma meta"
                            style={{ width: '32%' }}
                            options={metas}
                            optionLabel="produto.nome"
                            dataKey="id"
                            onChange={(e) => {
                                if (e.value) {
                                    setMetaOperacao(e.value.operacoes[e.value.operacoes.length - 1]);
                                }
                                setMeta(e.value);
                            }}
                        />
                        <Dropdown
                            value={metaOperacao}
                            placeholder="Selecione uma operação"
                            style={{ width: '32%' }}
                            options={meta?.operacoes || []}
                            optionLabel="descricao"
                            dataKey="id"
                            onChange={(e) => {
                                setMetaOperacao(e.value);
                            }}
                        />
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", width: "100%", flexGrow: 1 }}>
                        <div style={{ display: "flex", width: "100%", background: "#240E92", color: "#FFF" }}>
                            <div style={{ width: "25%", borderColor: "#c8c8c8", borderWidth: 1, borderStyle: 'solid', padding: 5 }}>
                                <p style={{ color: "#FFF", fontSize: 18 }} >Meta/dia</p>
                                <p style={{ fontWeight: 700, fontSize: 28, textAlign: "center" }} >{metaComApontamentos?.quantidade}</p>
                            </div>
                            <div style={{ width: "25%", borderColor: "#c8c8c8", borderWidth: 1, borderStyle: 'solid', padding: 5 }}>
                                <p style={{ color: "#FFF", fontSize: 18 }}>Meta/hora</p>
                                <p style={{ fontWeight: 700, fontSize: 28, textAlign: "center" }}>{metaComApontamentos ?
                                    Math.floor(metaComApontamentos.quantidade / metaComApontamentos.horarios.length)
                                    : ""}</p>
                            </div>
                            <div style={{ width: "25%", borderColor: "#c8c8c8", borderWidth: 1, borderStyle: 'solid', padding: 5 }}>
                                <p style={{ fontSize: 18 }} >Produto</p>
                                <p style={{ fontWeight: 700, fontSize: 20, textAlign: "center" }}>{metaComApontamentos?.produto?.nome}</p>
                            </div>
                            <div style={{ width: "25%", borderColor: "#c8c8c8", borderWidth: 1, borderStyle: 'solid', padding: 5 }}>
                                <p style={{ fontSize: 18 }} >Cliente</p>
                                <p style={{ fontWeight: 700, fontSize: 20, textAlign: "center" }}>{metaComApontamentos?.cliente?.nome}</p>
                            </div>
                        </div>
                        <div style={{ display: "flex", width: "100%", background: "#f4f4f4" }}>
                            <div style={{ width: "50%", borderColor: "#c8c8c8", borderWidth: 1, borderStyle: 'solid', padding: 8 }}>
                                <p style={{ fontWeight: 700, fontSize: 28, textAlign: "center", margin: 0 }}>Realizado</p>
                            </div>
                            <div style={{ width: "50%", borderColor: "#c8c8c8", borderWidth: 1, borderStyle: 'solid', padding: 8, alignItems: "center" }}>
                                <p style={{ fontWeight: 700, fontSize: 28, textAlign: "center", margin: 0 }}>Saldo</p>
                            </div>
                        </div>
                        <div style={{ display: "flex", width: "100%", background: "#fff", flexGrow: 1 }}>
                            <div style={{ display: "flex", width: "50%", borderColor: "#c8c8c8", borderWidth: 1, borderStyle: 'solid', padding: 8, alignItems: "center", justifyContent: "center", flexGrow: 1 }}>
                                <p style={{ fontWeight: 700, fontSize: isDesktop() ? 144 : 64, textAlign: "center", margin: 0 }}>{total}</p>
                            </div>
                            <div style={{ display: "flex", width: "50%", borderColor: "#c8c8c8", borderWidth: 1, borderStyle: 'solid', padding: 8, alignItems: "center", justifyContent: "center", flexGrow: 1 }}>
                                <p style={{ fontWeight: 700, fontSize: isDesktop() ? 144 : 64, margin: 0 }}>{total - (metaComApontamentos?.quantidade || 0)}</p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}